<div>
  <span class="center text-neutral">{{ 'reservations.time-message' | translate }} </span>
  <div class="form-container">
    @for (scheduleKey of shifts(); track trackByKey($index, scheduleKey)) {
      <div>
        <h3> {{ scheduleKey | translate }} </h3>
        <div class="chip-container">
          @for (timeOption of schedule[scheduleKey]; track trackByKey($index, timeOption)) {
            <button
              class="chip-button"
              [ngClass]="{'selected': selected === timeOption}"
              (click)="onSelection(timeOption)">
              <p-chip>
                {{ timeOption | timeFormat }}
              </p-chip>
            </button>
          }
        </div>
      </div>
    }
  </div>
</div>